import styles from "./ConfirmPopup.module.scss";
import dangerIcon from "../../assets/images/icons/confirm-danger.svg";
import {useTranslation} from "react-i18next";
import React from "react";
import CustomButton from "../UI/CustomButton/CustomButton";

interface ConfirmPopupProps {
    text: string;
    clickOnYes: () => void | Promise<void>;
    clickOnCancel: () => void;
}

const ConfirmPopup: React.FC<ConfirmPopupProps> = ({clickOnCancel, clickOnYes, text}) => {

    const {t} = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.popup}>
                <img src={dangerIcon} alt="danger icon" />
                <h3 className={styles.title}>{text}</h3>
                <div className={styles.btnWrapper}>
                    <CustomButton text={t("Cancel")} type={"button"} typeStyle={"outline"} borderRadius={false} blueForOutline={true} functionOnClick={clickOnCancel}/>
                    <CustomButton text={t("Yes")} type={"button"} typeStyle={"fill"} borderRadius={false} functionOnClick={clickOnYes}/>
                </div>
            </div>
        </div>
    )
}

export default ConfirmPopup;